import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { SketchPicker, SliderPicker, CustomPicker, HuePicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectColorPickerColorType,
  setColorPickerColorType,
} from '../../../../redux/slicers/admin/curatorStylesSlicer';
import { ColorInput } from '../FormElements/ColorInput';
import { undoRedo } from '../UndoRedo/UndoRedo';
import styles from './ColorPicker.module.scss';
import { ColorTypeSwitcher } from './ColorTypeSwitcher';
import { EyeDropperButton } from './EyeDropperButton';
import { RgbPicker } from './RgbPicker';
import { ButtonV2 } from '../../../ButtonV2/ButtonV2';
import { EditIconV2 } from '../../../icons/EditIconV2';
import { curatorSelector } from '../../../../redux/slicers/admin/curatorSlicer';
import { v4 as uuidv4 } from 'uuid';

export const ColorPicker = CustomPicker(
  ({
    color,
    _colorType,
    onEdit,
    onColorTypeChange,
    className,
    rootClassName = '',
    hsv,
    rgb,
    hex,
    onChange,
    ...rest
  }) => {
    const idRef = useRef(null);
    const dispatch = useDispatch();
    const colorType = _colorType || useSelector(selectColorPickerColorType);
    const [colorPointerCoordinates, setColorPointerCoordinates] = useState(null); //{ top: 0, left: 0 });
    const sidebarActiveSection = useSelector((state) => curatorSelector(state).sidebarSection);

    const setColorType = (type) => {
      dispatch(setColorPickerColorType(type));
      undoRedo.settings.setColorPickerColorType({
        prevValue: colorType,
        nextValue: type,
      });
      onColorTypeChange && onColorTypeChange(type);
    };

    const setSketchPointerValue = ({ top, left, from }) => {
      const parent = document.getElementsByClassName('ColorPickerContainer');
      if (parent?.length) {
        for (let i = 0; i < parent?.length; i++) {
          const target = parent?.[i]?.querySelector('.saturation-black').nextSibling;
          target.style.top = top;
          target.style.left = left;
          console.log('DEBUG___color_top', { top, left, from });
        }
      }
    };

    useEffect(() => {
      idRef.current = uuidv4();
    }, [sidebarActiveSection]);

    useEffect(() => {
      console.log('DEBUG___color', {
        ...colorPointerCoordinates,
        id: idRef.current,
        sidebarActiveSection,
      });
      if (!colorPointerCoordinates) return;
      setSketchPointerValue(colorPointerCoordinates);
    }, [colorPointerCoordinates, sidebarActiveSection]);

    useEffect(() => {
      if (!sidebarActiveSection || !idRef.current) return;
      let timerIds = [];
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
          const style = mutationRecord.target.style;
          setTimeout(
            () =>
              setColorPointerCoordinates({
                top: style.top,
                left: style.left,
                from: 'new observer',
              }),
            50
          );
        });
      });

      const parent = document.getElementsByClassName('ColorPickerContainer');
      if (parent?.length) {
        for (let i = 0; i < parent?.length; i++) {
          const target = parent?.[i]?.querySelector('.saturation-black').nextSibling; // document.getElementsByClassName('saturation-black')[0].nextSibling;
          observer.observe(target, { attributes: true, attributeFilter: ['style'] });

          const timerId = setTimeout(
            () =>
              setColorPointerCoordinates({
                top: target.style.top,
                left: target.style.left,
                from: 'observer',
              }),
            50
          );
          timerIds?.push(timerId);
        }
      }

      return () => {
        idRef.current = null;
        setColorPointerCoordinates(null);
        observer.disconnect();
        timerIds?.forEach((t) => clearTimeout(t));
      };
    }, [sidebarActiveSection]);

    const handleChange = (clr) => {
      setColorPointerCoordinates({ ...colorPointerCoordinates, from: 'handleChange' });
      onChange(clr);
    };

    return (
      <div key={idRef.current} className={cx(styles.root, rootClassName, 'ColorPickerContainer')}>
        <SketchPicker
          // {...rest} this causing issues when onChangeComplete is triggered 2 times
          color={color}
          onChange={onChange}
          className={cx(styles.colorPicker, className)}
          disableAlpha
          styles={{
            default: {
              Alpha: {
                display: 'none',
              },
              Saturation: {
                display: 'none',
              },
              alpha: {
                display: 'none',
              },
            },
          }}
        />
        <div className="mb-5">
          <HuePicker
            color={color}
            onChange={handleChange}
            width="100%"
            pointer={HuePointer}
            className={styles.sliderPicker}
          />
        </div>
        {/* <HuePicker
        color={color}
        onChange={onChange}
        width="100%"
        height="40px"
        pointer={HuePointer}
        className={styles.huePicker}
        // styles={{
        //   default: {

        //     // picker: {
        //     //   width: 8
        //     // }
        //     // hue: {
        //     //   width: 8
        //     // }
        //   }
        // }}
        // className={styles.slider}
        // styles={{
        //   default: {
        //     Hue: {
        //       display: 'none',
        //       height: '40px',
        //       borderRadius: '0px 0px 8px 8px',
        //       marginTop: '2px',
        //     },
        //   }
        // }}
      /> */}
        <div className={`my-3 ${styles.topRow}`}>
          <ColorTypeSwitcher value={colorType} onChange={setColorType} />
          <EyeDropperButton onChange={onChange} />
          <ColorInput value={hex} onChange={onChange} className={`${styles.colorInput} ${rest?.inputClassName}`} />
        </div>

        <RgbPicker color={color} hsv={hsv} rgb={rgb} onChange={onChange} colorType={colorType} />

        <div className="my-3" />

        {onEdit && (
          <ButtonV2 onClick={onEdit} className={cx(styles.editButton)} color="dark">
            <EditIconV2 />
          </ButtonV2>
        )}
      </div>
    );
  }
);

const HuePointer = () => {
  return <div className={styles.huePointer} />;
};

const SliderPointer = () => {
  return <div className={styles.sliderPointer} />;
};
